import { Pipe, PipeTransform } from '@angular/core';
import { NotificationService } from '@sharedServices/notification.service';
import imageCompression from 'browser-image-compression'
import { environment } from '@environment';

@Pipe({
  name: 'encodeFile'
})

export class EncodeFilePipe implements PipeTransform {

  constructor(
    private notificationService: NotificationService
  ) {}

  /**
   * transform
   * @param fileList - Array of file(s) to be encoded
   * @param maxFileSize - Set max file upload size in MB (optional)
   * @return any[] - Array containing { fileBase64 & originalFile }
   */
  transform(fileList: File[] | FileList, maxFileSize: number = environment.max_file_upload_size): Promise<any[]> {
    let promiseArr: any = []

    return new Promise((resolve) => {
      Array.from(fileList).forEach((file: File) => {
        const promise = new Promise((resolve, reject) => {
          if(file.size > (maxFileSize * 1048576)) {
            this.notificationService.showWarning(`Skipping file "${file.name}" as it exceeds upload limit of ${maxFileSize} MB...`, 'Upload Limit Exceeded')
            reject(`${file.name} exceeds upload limit of ${maxFileSize}MB`)
          } else {
            imageCompression.getDataUrlFromFile(file).then((base64Str: string) => {
              const responseObj = {
                fileBase64: base64Str.split(',')[1],
                originalFile: file
              }
              resolve(responseObj)
            }).catch(() => {
              this.notificationService.showError(`Unable to encode "${file.name}" as file is corrupted/damaged`, 'Encoding Error')
              reject(`${file.name} is corrupted/damaged`)
            })
          }
        })
        promiseArr.push(promise)
      })
      Promise.all(
        promiseArr.map((promise) =>
          promise.catch(() => null)
        )
      ).then((values: any) => {
        resolve(values.filter(value => value))
      })
    })
  }
}
